import { useGetList } from 'react-admin';

const useVenues = () => {
  const { data, isLoading, error } = useGetList('venues', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'name', order: 'ASC' },
  });

  if (isLoading || error || !data) {
    return [];
  }

  return data.map((venue) => ({
    id: venue.id,
    label: venue.name || venue.id,
  }));
};

export default useVenues;
